import type { IUiLinkMap } from '@experiences/interfaces';

export const KerberosSetupLinks: IUiLinkMap = new Map([
    [ 'en', 'https://docs.uipath.com/automation-suite/docs/setting-up-kerberos-authentication' ],
    [ 'ja', 'https://docs.uipath.com/automation-suite/lang-ja/docs/setting-up-kerberos-authentication' ],
]);
